// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Flex } from '@iheartjane/reefer';
import { transparentize } from 'polished';

import { CircledCheckIcon } from './Icons/CircledCheckIcon';

export const OrderCompleteContainer = styled(Flex)(({ theme }) => ({
  backgroundColor: theme.colors.primary.main,
}));

export const OrderCompleteCheckIcon = styled(CircledCheckIcon)(({ theme }) => ({
  color: theme.colors.text.info,
}));

export const OrderCompleteSubContainer = styled(Flex)(({ theme }) => ({
  backgroundColor: transparentize(0.9, theme.colors.text.info),
  borderRadius: theme.borderRadius.lg,
}));
